import React from 'react';
import useDocumentTitle from "../common/UseDocumentTitle";

const ErrorPage = () => {
    useDocumentTitle('Error page');
    return (
        <div style={{ marginTop: '1.875rem', marginLeft: '1.25rem' }}>
            <h1 className="inputText" style={{ fontSize: '1.75rem', margin: 0 }}>Error</h1>

            <div style={{ marginTop: '2.5rem' }}>
                <p className="inputText">
                    Access Denied. You do not have permission to access this page in PowerEngage. Please contact your system <br />
                    administrator if you believe this is an error or if you require this access.
                </p>
            </div>
        </div>
    );
};

export default ErrorPage;
